// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"393":"965217a8","4344":"9fe06b97"}[chunkId] + ".chunk.css";
};